import { Grid } from '@material-ui/core';
import { EnderecoVisualizar } from 'app/main/pessoa/Endereco';
import React from 'react';

function EnderecoPanel({ transportadora }) {
  const {
    pessoa: { endereco = {} },
  } = transportadora;

  return (
    <Grid container spacing={3}>
      <EnderecoVisualizar endereco={endereco} />
    </Grid>
  );
}

export default EnderecoPanel;
